import { tallyArrayByProp, sumPriceAndAmount } from "../utils";

const initialState = {
  basket: [],
  totalPrice: 0,
  totalItems: 0,
};

function basket(state = initialState, action) {
  switch (action.type) {
    case "ADDED_TO_BASKET": {
      const { item } = action;
      let newBasket = JSON.parse(JSON.stringify(state.basket));
      newBasket.push(item);
      newBasket = tallyArrayByProp(newBasket, "amount");
      const { totalPrice, totalItems } = sumPriceAndAmount(newBasket);
      return { ...state, basket: newBasket, totalPrice, totalItems };
    }
    case "REMOVED_FROM_BASKET": {
      const { item } = action;
      let newBasket = JSON.parse(JSON.stringify(state.basket));
      for (let i = 0; i < newBasket.length; i++) {
        if (newBasket[i].uid === item.uid) {
          newBasket[i].amount -= 1;
          if (newBasket[i].amount === 0) {
            newBasket.splice(i, 1);
          }
        }
      }
      newBasket = tallyArrayByProp(newBasket, "amount");
      const { totalPrice, totalItems } = sumPriceAndAmount(newBasket);
      return { ...state, basket: newBasket, totalPrice, totalItems };
    }
    case "CLEARED_BASKET": {
        return { ...state, basket: [], totalPrice: 0, totalItems: 0 };
      }
    default:
      return state;
  }
}

export default basket;
